import { useTranslation } from "react-i18next";
import { Params, UIMatch, useMatches } from "react-router";

import { NavigationMenuLinks } from "@/components/NavigationMenu";

export type CustomUIMatch = UIMatch<
  unknown,
  {
    breadcrumb?: (params: Params) => {
      href: string;
      label: string;
    }[];
    isOverlayed?: boolean;
    activeMenuLink?: NavigationMenuLinks;
  }
>;

const useBreadcrumbs = () => {
  const { t } = useTranslation(["navigation-menu", "reviewCategories"]);
  const matches = useMatches() as CustomUIMatch[];

  const crumbs = matches
    // first get rid of any matches that don't have handle and breadcrumb
    .filter((match) => Boolean(match.handle?.breadcrumb))
    // now map them into an array of elements, passing the params to each one
    .map((match) => match.handle.breadcrumb!(match.params))
    .filter(Boolean) // remove any null or empty array needed for routes that retunr no breadcrumb
    .flat(); // flatten the array of arrays (needed for routes that return multiple breadcrumbs)

  // replace the labels in crumbs with the translated ones
  crumbs.forEach((crumb) => {
    crumb.label = t(crumb.label);
  });

  const isOverlayed = matches[matches.length - 1]?.handle?.isOverlayed;

  return { crumbs, isOverlayed };
};

export default useBreadcrumbs;
